// The pop-up tooltips that appear in names
import selectAll from '../utils/select-all';
import clamp from '../utils/clamp';
import text from '../../../data/text.json'; // Text data
import loadAssetURL from '../utils/load-assets-url';

const Timeline = document.getElementById('timeline');
const popUps = selectAll('.hover-over', Timeline);
let popUpsText = text['pop_ups'];
let tooltip = document.querySelector('.tooltip');

popUps.forEach(el => {
  el.addEventListener('click', e => {
    const element = e.target;

    const target = element.getAttribute('data-bio-id');

    element.setAttribute('aria-expanded', 'true')

    const divOffset = offset(element);
    const position = element.getBoundingClientRect();
    const x = divOffset.left;

    // How far down the page it is
    const y = divOffset.top;

    // How far it is from the window
    const pageY = position.top;

    tooltip.className = tooltip.className.replace(/\bis-hidden\b/g, '');

    relocateTooltip(tooltip, x, y, pageY);

    let tooltip_div = getTooltip(target);

    tooltip.innerHTML = tooltip_div;
  });
  el.addEventListener('mouseenter', e => {
    const element = e.target;

    const target = element.getAttribute('data-bio-id');
    element.setAttribute('aria-expanded', 'true');

    const divOffset = offset(element);
    const position = element.getBoundingClientRect();
    const x = divOffset.left;

    // How far down the page it is
    const y = divOffset.top;

    // How far it is from the window
    const pageY = position.top;

    tooltip.className = tooltip.className.replace(/\bis-hidden\b/g, '');

    relocateTooltip(tooltip, x, y, pageY);

    let tooltip_div = getTooltip(target);

    tooltip.innerHTML = tooltip_div;
  });

  el.addEventListener('mouseleave', e => {
    e.preventDefault();
    // Add the hidden class back

    const element = e.target;

    element.setAttribute('aria-expanded', 'false')

    const name = 'is-hidden';
    const arr = tooltip.className.split(' ');
    if (arr.indexOf(name) == -1) {
      tooltip.className += ' ' + name;
    }
  });
  el.addEventListener('keydown', (e) => {
  if (e.code === 'Space' || e.code === 'Enter') {
    el.click();
  }
});
});

const tooltipPush = 30;

const relocateTooltip = (tooltip, x, y, pageY) => {
  const { height, width } = tooltip.getBoundingClientRect();

  const innerWidth = window.innerWidth;
  const innerHeight = window.innerHeight;

  const left = clamp(x - 10, tooltipPush, innerWidth - width - tooltipPush);
  const top =
    innerHeight > pageY + tooltipPush + height
      ? y + tooltipPush + 5
      : y - height - 10;

  tooltip.style.left = `${left}px`;
  tooltip.style.top = `${top}px`;
};

const getTooltip = target => {
  let popUpPerson = popUpsText.filter(person => person.type == target)[0];

  const placeholder_pic = loadAssetURL(`${popUpPerson.value.image}`);

  let location;
  
  if (popUpPerson.value.location) {
    location = `<div class="caption-location"><span class="c-icon c-icon--baseline"><svg aria-hidden="true"><use xlink:href="#location"></use></svg></span>${popUpPerson.value.location}</div>`
  } else {location = ``};

  let div = `<div class="hover-over-container"><div class="headshot-small-container"><img class="headshot-small" data-sizes="auto" sizes="66px" src="${placeholder_pic}" alt="${popUpPerson.value.image_alt}" /></div><div class="caption caption-small"><div class="caption-name">${popUpPerson.value.caption_name}</div><div class="caption-nursing-home">${popUpPerson.value.caption_nursing_home}</div>${location}</div></div>`;

  return div;
};

function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}
